import { docsIndexFlat } from './docsIndex';
import WithMDXProvider from './MDXProviderSetup';
import { useLocation } from 'react-router-dom';
import './docPage.css';

export default function DocPage() {
  const location = useLocation();

  const fullPath = location.pathname;

  const slug = fullPath.replace(/^\/documentation\/?/, '') || '';

  console.log('docsIndexFlat:', docsIndexFlat);
  console.log('fullPath:', fullPath);
  console.log('slug:', slug);

  const entry = docsIndexFlat.find((d) => d.slug === slug) || docsIndexFlat.find((d) => d.isIndex) || docsIndexFlat[0];

  if (!entry) return <div>No docs found.</div>;

  const Component = entry.Component;
  return (
    <WithMDXProvider>
      <Component />
    </WithMDXProvider>
  );
}
